import Icon from '../components/Icon.vue'

Icon.register({
  'piggy-bank': {
    width: 576,
    height: 512,
    paths: [
      {
        d: 'M560 224c8.8 0 16 7.2 16 16v128c0 8.8-7.2 16-16 16h-48.7c-9 11.9-19.5 22.4-31.3 31.3v80.7c0 8.8-7.2 16-16 16h-64c-8.8 0-16-7.2-16-16v-48h-128v48c0 8.8-7.2 16-16 16h-64c-8.8 0-16-7.2-16-16v-80.7c-38.6-29.2-64-75.1-64-127.3h-40c-33.3 0-59.9-29.2-55.5-63.4 3.6-28.2 29-48.6 57.5-48.6 3.3 0 6 2.7 6 6v20c0 3.3-2.7 6-6 6h-1c-11.6 0-22.3 7.8-24.5 19.2-3 15.3 8.7 28.8 23.5 28.8h43.2c14.9-73 79.4-128 156.8-128h128c7.9 0 15.4 1.2 23 2.3 17.6-20.8 43.6-34.3 73-34.3h32l-18.9 75.5c15.8 14.8 28.6 32.5 37.4 52.5h29.5zM432 288c8.8 0 16-7.2 16-16s-7.2-16-16-16-16 7.2-16 16 7.2 16 16 16zM256 96c-16.4 0-32.2 2.3-47.4 6.2-0.1-2.1-0.6-4.1-0.6-6.2 0-53 43-96 96-96s96 43 96 96c0 0.3-0.1 0.5-0.1 0.8-5.2-0.4-10.5-0.8-15.9-0.8h-128z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/piggy-bank.js
// module id = 1639
// module chunks = 0